import { Component, OnInit, ViewChild } from "@angular/core";
import { MatDialog } from "@angular/material/dialog";
import { CardTableComponent } from "src/app/components/cards/card-table/card-table.component";
import { Condition } from "src/app/models/custom-types";
import { FilterEvent } from "src/app/models/filter";
import { ListColumn } from "src/app/models/list-columns.model";
import { TiposServicioDTO } from "src/app/models/tipo-servicio.dto";
import { UnidadesDTO } from "src/app/models/unidades.dto";
import { AlertasSwalService } from "src/app/services/alerts.service";
import { Filter } from "src/app/shared/classes/filter";
import { TiposServiciosService } from "../../catalogs/tipos-servicios/tipos-servicios.service";
import { MantProgramarHistorialModal } from "./historial/modal.component";
import { ProgramarModal } from "./modal/modal.component";
import { ProgramarService } from "./programar.service";

@Component({
  selector: "app-programar",
  templateUrl: "./programar.component.html",
  styles: [],
})
export class ProgramarComponent implements OnInit {
  public columns: ListColumn[] = [
    {
      name: "# Control",
      property: "NoControl",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Modelo",
      property: "Modelo",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Placas",
      property: "Placas",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Serie",
      property: "Serie",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Tipo Unidad",
      property: "TipoUnidad",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "Empresa",
      property: "Empresa",
      visible: true,
      isModelProperty: true,
      useFilter: true,
    },
    {
      name: "actions",
      property: "actions",
      visible: true,
      isModelProperty: false,
    },
  ];

  public actions: any[] = [
    {
      desc: "Historial mantenimientos",
      action: "historial",
      visible: (row) => true,
    },
    {
      desc: "Programar mantenimiento (preventivo)",
      action: "preventivo",
      visible: (row) => true,
    },
    {
      desc: "Mandar a taller (correctivo)",
      action: "correctivo",
      visible: (row) => true,
    },
  ];

  @ViewChild(CardTableComponent, { static: true })
  public tableComp: CardTableComponent;

  filtro: string = "";
  inactivos: boolean = false;
  realdata: UnidadesDTO[] = [];
  listTipos: TiposServicioDTO[] = [];

  constructor(
    public service: ProgramarService,
    public tpservService: TiposServiciosService,
    public dialog: MatDialog,
    public alerts: AlertasSwalService
  ) {}

  ngOnInit(): void {
    this.loadRecords();
    this.loadTiposServicios();
    this.filter = new Filter<UnidadesDTO>(this.conditions, this.columns, true);
  }
  loadRecords() {
    this.service.get().subscribe(
      (resultData) => {
        this.realdata = resultData;
        this.filter.setDataTable(this.realdata, this.tableComp);
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
  loadTiposServicios() {
    this.tpservService.get().subscribe(
      (resultData) => {
        this.listTipos = resultData;
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }

  //#region Filter

  public filter: Filter<UnidadesDTO>;
  public conditions: Condition<UnidadesDTO> = {
    NoControl: (o, f) => o.NoControl.toLocaleLowerCase().indexOf(f) > -1,
    Modelo: (o, f) =>
      (o.Modelo ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Placas: (o, f) =>
      (o.Placas ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Serie: (o, f) =>
      (o.Serie ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    TipoUnidad: (o, f) =>
      (o.TipoUnidad ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
    Empresa: (o, f) =>
      (o.Empresa ?? "").toString().toLocaleLowerCase().indexOf(f) > -1,
  };

  filterdata(e: FilterEvent) {
    this.filter.filterdata(e, this.realdata, this.tableComp);
  }

  //#endregion Filter

  actionstable(e: { action: string; row: any }) {
    if (e.action == "historial") {
      this.opendialoghistorial(e.row);
    } else if (e.action == "preventivo") {
      this.openDialog(e.row);
    } else if (e.action == "correctivo") {
      this.alerts
        .ask({
          title:
            "Seguro que quieres crear un mantenimiento correctivo para esta unidad?",
          text: "Esta accion es irreversible!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Si",
          cancelButtonText: "No",
        })
        .then((result) => {
          if (result.isConfirmed) {
            this.openDialogNotDate(e.row);
          }
        });
    }
  }

  async opendialoghistorial(row) {
    await this.dialog
      .open(MantProgramarHistorialModal, {
        panelClass: ["modal-for-table", "w-1/2"],
        data: row.IdUnidad,
      })
      .afterClosed()
      .toPromise();

    this.loadRecords();
  }

  async openDialog(row) {
    const result = await this.dialog
      .open(ProgramarModal, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: {
          needDate: true,
          tiposServicios: this.listTipos,
        },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.crear(
        row,
        2,
        result.FechaProgramado,
        result.Razon,
        result.ReparacionOServicio,
        result.Servicio
      );
    }
  }

  async openDialogNotDate(row) {
    const result = await this.dialog
      .open(ProgramarModal, {
        panelClass: ["w-full", "lg:w-1/2"],
        data: {
          needDate: false,
          tiposServicios: this.listTipos,
        },
      })
      .afterClosed()
      .toPromise();

    if (result) {
      this.crear(
        row,
        1,
        new Date(),
        result.Razon,
        result.ReparacionOServicio,
        result.Servicio
      );
    }
  }

  crear(
    row: any,
    Tipo: number,
    FechaProgramado: Date,
    Razon: string,
    ReparacionOServicio: any,
    Servicio: any
  ) {
    this.service
      .crear({
        IdUnidad: row.IdUnidad,
        Tipo,
        FechaProgramado,
        Razon,
        TipoMt: ReparacionOServicio,
        IdTipoServicio: Servicio,
      })
      .subscribe(
        (next) => {
          this.alerts.correcta("Creado", "Accion realizada correctamente");
          this.loadRecords();
        },
        (err) => {
          this.alerts.error("error", err.error.Message);
        }
      );
  }
  terminar(row: any) {
    this.service.terminar(row.IdMantenimiento).subscribe(
      (next) => {
        this.alerts.correcta("Activado", "Accion realizada correctamente");
        this.loadRecords();
      },
      (err) => {
        this.alerts.error("error", err.error.Message);
      }
    );
  }
}
